import React, { useState } from "react";
import { RazorPayPayment } from "../Payment/RazorPayPayment"
import LoaderOverlay from "src/Payment/LoaderOverlay";

const CartPage = ({ items, isDiscount,AddNewSponsorGrowniverseId }) => {
    const [loader, setLoader] = useState(false);
    const subtotal = items.reduce((acc, item) => acc + item.coursePrice, 0);
    const discountCourses = (coursePrice: number) => {
        const discounted = coursePrice - (coursePrice * 0.10);

        // Round to nearest integer
        return Math.round(discounted);
    };

    // Round to nearest integer (whole rupee)
    const roundHalfDown = (num) => {
        const decimal = num % 1;
        const integer = Math.floor(num);
        if (decimal === 0.5) {
            return integer; // half-down rule
        }
        return Math.round(num);
    };

    const handleCartPayment = () => {
        setLoader(true);
        debugger
        const courseIds = items?.map(item => item.courseId) ?? null;
        RazorPayPayment((isDiscount ? discountCourses(subtotal) : roundHalfDown(subtotal)) * 100, 0, AddNewSponsorGrowniverseId,courseIds);
    };

    return (
        <>
            {
                loader &&
                <LoaderOverlay open={loader} />
            }
            <div
                style={{
                    minHeight: "100vh",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    background: "radial-gradient(circle at center, #0d0d1a, #000000)",
                    padding: "40px",
                    position: "relative",
                    overflow: "hidden"
                }}
            >
                {/* Animated stars */}
                <div className="stars"></div>
                <div className="stars2"></div>
                <div className="stars3"></div>

                <h1 style={{ marginBottom: "30px", color: "#fff", fontWeight: 700 }}>
                    🛒 Your Cart
                </h1>

                <div
                    style={{
                        background: "#fff",
                        borderRadius: "12px",
                        padding: "25px",
                        width: "100%",
                        boxShadow: "0 6px 20px rgba(0,0,0,0.4)",
                        borderTop: "4px solid #1E88E5",
                        zIndex: 10
                    }}
                >
                    {items.length === 0 ? (
                        <p style={{ textAlign: "center", color: "#777" }}>No items in cart.</p>
                    ) : (
                        items.map((item, index) => (
                            <div
                                key={item.courseId}
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    marginBottom: "12px",
                                    borderBottom: "1px solid #eee",
                                    paddingBottom: "10px"
                                }}
                            >
                                {/* Left side: index + course name */}
                                <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                                    <span style={{ fontWeight: "bold", color: "black", fontSize: "20px" }}>{index + 1}.</span>
                                    <span style={{ fontWeight: "bold", color: "black", fontSize: "15px" }}>
                                        {item.courseName}
                                    </span>
                                </div>

                                {/* Right side: price */}
                                <span style={{ color: "#25da73", fontWeight: "bold", fontSize: "20px" }}>
                                    ₹{isDiscount ? discountCourses(item.coursePrice) : roundHalfDown(item.coursePrice)}
                                </span>
                            </div>
                        ))

                    )}

                    {/* Billing Section */}
                    <div
                        style={{
                            marginTop: "20px",
                            padding: "20px",
                            borderTop: "2px solid #ddd",
                            fontWeight: "bold",
                            fontSize: "15px"
                        }}
                    >
                        {/* Subtotal */}
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                marginBottom: "8px",
                                color: "#333", // neutral dark
                                fontSize: "18px"
                            }}
                        >
                            <span>Subtotal:</span>
                            <span>₹{isDiscount ? discountCourses(subtotal) : roundHalfDown(subtotal)}</span>
                        </div>

                        {/* Total */}
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                color: "#2E7D32", // highlight green
                                fontWeight: "bold",
                                fontSize: "20px",
                                borderTop: "1px solid #ccc",
                                paddingTop: "10px"
                            }}
                        >
                            <span>Total:</span>
                            <span>₹{isDiscount ? discountCourses(subtotal) : roundHalfDown(subtotal)}</span>
                        </div>
                    </div>


                    {/* Next Button */}
                    <button
                        style={{
                            marginTop: "25px",
                            width: "100%",
                            padding: "14px",
                            borderRadius: "8px",
                            background: "#1E88E5",
                            color: "#fff",
                            fontSize: "16px",
                            fontWeight: 600,
                            border: "none",
                            cursor: "pointer",
                            transition: "all 0.3s ease",
                            boxShadow: "0 4px 10px rgba(0,0,0,0.3)"
                        }}
                        onClick={handleCartPayment}
                    >
                        Proceed to Payment
                    </button>
                </div>

                {/* Universe background animation */}
                <style>
                    {`
          .stars, .stars2, .stars3 {
            position: absolute;
            width: 100%;
            height: 100%;
            background: transparent url('https://www.script-tutorials.com/demos/360/images/stars.png') repeat top center;
            animation: moveStars 60s linear infinite;
          }
          .stars2 {
            background-size: 2px 2px;
            animation: moveStars 120s linear infinite;
            opacity: 0.5;
          }
          .stars3 {
            background-size: 3px 3px;
            animation: moveStars 180s linear infinite;
            opacity: 0.3;
          }
          @keyframes moveStars {
            from { transform: translateY(0); }
            to { transform: translateY(-1000px); }
          }
        `}
                </style>
            </div>
        </>
    );
};

export default CartPage;
